<template>
  <div class="product-block relative" v-on-clickaway="closeSelect">
  <div :class="hasResults ? 'active' : ''">
    <div class="relative">
      <InputText
        v-if="!selected || !selected.id"
        :label="label"
        v-model="inputSearch"
        @keyup.native="search"
        :rules="{required: true}"/>
      <div v-else>
        <div class="input-text">
          <label v-if="label">{{ label }}
            <span class="warning-color">*</span>
          </label>
        </div>
        <div class="product-selected-container">
          <div class="product-image">
            <img v-if="selected.image" :src="selected.image" />
            <svg viewBox="-13 -13 50 50" class="no-image" v-else><path d='M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z'></path></svg>
          </div>
          <div class="m-l-10 product-description-box">
            <div class="product-description">
              <div class="product-title">{{ selected.name }}</div>
              <div class="product-sub-title"><span v-if="selected.sku_code">SKU: {{ selected.sku_code }}</span> <span v-else-if="selected.ean_number">EAN: {{ selected.ean_number }}</span></div>
            </div>
            <div class="product-remove" @click="removeProduct">
              <Icon class="d-inline-block" name="remove" size="25" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="search-result-dropdown" v-show="hasResults">
      <div v-if="results.length > 0">
        <ul>
          <li
            v-for="(item, index) in get_items_list" :key="`predA-${index}`"
            :ref="`${index}-opt`"
            tabIndex="-1"
            class="list-item"
            @keydown.prevent="nextItemList"
            @click="setProduct(item)">
            <div class="product-image">
              <img v-if="item.image" :src="item.image" />
              <svg viewBox="-13 -13 50 50" class="no-image" v-else><path d='M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z'></path></svg>
            </div>
            <div class="product-description m-l-20">
              <div v-html="highlight(item.name)"></div>
              <div><span v-if="item.sku_code">SKU: <span v-html="highlight(item.sku_code)"></span></span> <span v-if="item.ean_number && item.sku_code">&bull;</span> <span v-if="item.ean_number">EAN: <span v-html="highlight(item.ean_number)"></span></span></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
/* eslint-disable */
import InputText from '@/components/elements/inputs/text.vue';
import { directive as onClickaway } from 'vue-clickaway';
import _ from "lodash";
import countryList from "@/data/country";
import {mapGetters} from "vuex";
import sanitize from '@/mixins/sanitize';

export default {
  name: 'productPicker',
  components: {
    InputText,
  },
  directives: {
    onClickaway,
  },
  mixins: [sanitize],
  props: {
    label: {
      type: String,
      default: 'description',
    },
    placeholder: {
      type: String,
      default: 'Type your product name',
    },
    value: {
      type: String,
      default: '',
    },
    product: {
      type: Object,
      default: () => {},
    },
    allPackedInOne: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      indexItem: 0,
      selected: {},
      service: {},
      inputSearch: '',
      hasResults: false,
      results: [],
      defaultObject: {
        qty: 1,
        description: '',
        unitValue: {
          value: 0,
          unit: 'eur',
        },
        unitWeight: {
          unit: 'kg',
          value: '',
        },
        hsCode: '',
        origin: '',
      }
    };
  },
  computed: {
    ...mapGetters(['get_items_list']),
    randomSelectId() {
      return `select-${this.randomNumber()}`
    }
  },
  watch: {
    inputSearch(newVal) {
      this.$emit('input', newVal)
    },
    value(newVal) {
      this.inputSearch = newVal
      this.selected = this.product
    }
  },
  mounted() {
    this.inputSearch = this.value
    this.selected = this.product
  },
  methods: {
    highlight(itemToHighlight) {
      // Security fix: use safeHighlight from sanitize mixin to prevent XSS
      return this.safeHighlight(itemToHighlight, this.inputSearch);
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    nextItemList(event) {
      if (event.keyCode === 9) return;
      if (event.keyCode === 38 && this.indexItem > 0) {
        this.indexItem--;
        this.$refs[`${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode === 40 && this.indexItem < this.results.length - 1) {
        this.indexItem++;
        this.$refs[`${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode === 13) {
        this.$refs[`${this.indexItem}-opt`][0].click();
      }
    },
    removeProduct() {
      this.inputSearch = ''
      this.selected = {}
      this.$emit('productRemoved', this.defaultObject);
    },
    setProduct(item) {
      this.selected = item;
      this.hasResults = false;
      this.inputSearch = item.name;
      this.$emit('productSelected', item);
    },
    search: _.debounce(function(event) {
      if(event.keyCode === 9) return;
      if (event.keyCode === 38 || event.keyCode === 40) {
        if(this.results.length > 0){
          this.$refs[`${this.indexItem}-opt`][0].focus();
        }
        return;
      }
      if(this.inputSearch !== ''){
          this.$store.dispatch('GET_ITEMS', {page : 1, query : `&type_id=1&searchTerm=${this.inputSearch}`}).then((r) => {
            this.hasResults = this.get_items_list.length !== 0;
            if (this.hasResults) {
              this.results = this.get_items_list
            }
          });
      } else {
        this.hasResults = false;
      }
    }, 200),
    closeSelect() {
      this.hasResults = false;
    },
  }
}
</script>

<style scoped>
.search-result-dropdown {
    position: absolute;
    top: 68px;
    width: 400px;
    padding: 30px;
    box-shadow: 0px 0px 8px 0px #a0a0a0;
    background: white;
    z-index: 1;
    border-left: 1px solid #DBDFE3;
    border-right: 1px solid #DBDFE3;
    border-radius: 0 0 4px 4px;
}

.list-item {

  position: relative;
  padding: 9px;
  border-radius: 4px;
  display: block;
  margin-bottom: 5px;
  font-size: 14.5px !important;
  font-weight: 500;
  cursor: pointer;

  b{
    color: $color-dark;
    font-weight: 400;
  }

  .item-flag{
    position: absolute;
    right: 9px;
    top: 6px;
  }

  .icon{
    vertical-align: middle;
    margin-right: 18px;
  }

  span{
    vertical-align: middle;
    font-weight: 300;
  }
}


.list-item.active, .list-item:hover{
  background-color: #F2F4F6;
}

.list-item:focus{
  border: none;
  outline: none;
  background-color: #F2F4F6;
}

.product-block .search-result-dropdown li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.product-image {
  width: 40px;
  height: 40px;
  position: relative;
  display: flex;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid #DBDFE3;
}

.product-image > img {
  position: absolute;
  top: -9999px;
  bottom: -9999px;
  left: -9999px;
  right: -9999px;
  margin: auto;
  max-height: 40px;
  max-width: 40px;
}

.product-image > .no-image {
  background: #F2F4F6;
  fill: $color-light;
}

.product-description > div  {
  display: block;
  margin-bottom: 4px;
}

.product-description span {
  font-size: 13px !important;
  margin-bottom: 0;
  color: #989FA6;
  font-weight: 400;
}

.product-selected-container {
  height: 45px;
  padding: 2px;
  font-size: 12px;
  border: 1px solid #DBDFE3;
  border-radius: 4px;
  color: #989FA6;
  display: flex;
}

.product-selected-container .product-description {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.product-selected-container .product-title {
  font-size: 11px !important;
  color: #363D44;
}

.product-selected-container .product-description-box {
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
}

.product-selected-container .product-image {
  width: 40px;
  height: auto;
}

.product-selected-container .product-description > div {
  margin-bottom: 0;
}

.product-selected-container .product-description-box .product-remove {
  display: flex;
  background: #f2f4f6;
  width: 28px;
  align-items: center;
  cursor: pointer;
  border-radius: 3px;
  justify-content: center;
}

.product-selected-container .product-sub-title  span {
  color: #989FA6;
  font-size: 8px !important;
}
</style>
